module.exports = __webpack_public_path__ + "img/example_banner.447ca0be.png";